import {useState, useRef, useEffect, useContext} from "react";
import {Link, useNavigate} from "react-router-dom";
import {AuthContext} from "../contexts/AuthContext";


export default function LoginDropdown({onLogout}) {

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    const {user, logout} = useContext(AuthContext);
    const username = user?.username || "";
    const role = user?.role || "";
    const normalizedRole = role.toLowerCase().trim();

    const isAdminOrHeadOffice = () =>
        normalizedRole === "admin" || normalizedRole === "head office";

    const handleLogout = async () => {
        await logout();
        setIsOpen(false);
        if (onLogout) onLogout();
        navigate("/");
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="relative inline-block text-left" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen((prev) => !prev)}
                className="bg-[#f3a648] text-primarypx-4 py-1 rounded-full font-semibold shadow hover:bg-opacity-90 transition"
            >
                {role || "no role"} {username || "Login"}
            </button>

            <div
                className={`absolute right-0 mt-2 max-w-xs w-full sm:w-48 bg-primary rounded-lg shadow-lg z-50 transition-all duration-200 ease-out ${
                    isOpen ? "opacity-100 scale-100 visible" : "opacity-0 scale-95 invisible"
                }`}
                style={{minWidth: "160px"}}
            >
                <Link
                    to="/profile"
                    className="block px-4 py-3 text-[#F2F1F0] font-semibold hover:bg-[#f3a648] hover:text-primarytransition rounded-t-lg"
                    onClick={() => setIsOpen(false)}
                >
                    Profile
                </Link>


                <Link
                    to="/messages/acknowledged"
                    className="block px-4 py-3 text-[#F2F1F0] font-semibold hover:bg-[#f3a648] hover:text-primarytransition"
                    onClick={() => setIsOpen(false)}
                >
                    Messages
                </Link>


                {isAdminOrHeadOffice() && (
                    <>
                        <Link
                            to="/admin/dashboard"
                            className="block px-4 py-3 text-[#F2F1F0] font-semibold hover:bg-[#f3a648] hover:text-primarytransition"
                            onClick={() => setIsOpen(false)}
                        >
                            Dashboard
                        </Link>

                        <Link
                            to="/admin/bookings"
                            className="block px-4 py-3 text-[#F2F1F0] font-semibold hover:bg-[#f3a648] hover:text-primarytransition"
                            onClick={() => setIsOpen(false)}
                        >
                            Bookings
                        </Link>
                    </>
                )}

                <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-3 text-[#F2F1F0] font-semibold hover:bg-[#f3a648] hover:text-primarytransition rounded-b-lg"
                >
                    Logout
                </button>
            </div>
        </div>
    );
}
